export default __webpack_public_path__ + "static/Routeburn-Track-credit-lwtt93-afcc6cd149fa2e10df784376f3ca686e.jpg";